import React from 'react'
import ReactModal from 'react-modal'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ReactComponent as UpcomingDropdown } from '../../../assets/svg/UpcomingDropdown.svg'
import Loading from '../../Loading'
import FabButton from '../../dashboard/FabButton'
import ContentListSkeleton from './ContentListSkeleton'
import '../../../styles/modals/UpcomingContentModal.css'

/**
 * Right-docked, full-height list panel used by the Upcoming and Review
 * content modals. Presentation only: pagination state comes from
 * usePagedContentList in the wrapper.
 *
 * Object-form class names mean react-modal adds none of its default
 * `ReactModal__*` classes, so the app-wide transition rules in
 * TargetGroupModal.css cannot reach this panel; its motion is scoped in
 * dashboardMotion.css (dsh-panel*). closeTimeoutMS must cover the longest
 * of those transitions.
 */
export const PANEL_TIMEOUT = 280

const PANEL_CLASS = { base: 'dsh-panel', afterOpen: 'dsh-panel--open', beforeClose: 'dsh-panel--closing' }
const OVERLAY_CLASS = { base: 'dsh-panel-overlay', afterOpen: 'dsh-panel-overlay--open', beforeClose: 'dsh-panel-overlay--closing' }

function ContentListModal({
    isOpen,
    onClose,
    onAfterClose,
    title,
    ariaLabel,
    headerContent,
    items,
    loading,
    refreshing,
    hasMore,
    version,
    loadMore,
    emptyText,
    renderRow,
    scrollId,
    closeButton,
    zIndex = 100,
    children,
}) {
    const isEmpty = !loading && items.length === 0

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onClose}
            onAfterClose={onAfterClose}
            closeTimeoutMS={PANEL_TIMEOUT}
            className={PANEL_CLASS}
            overlayClassName={OVERLAY_CLASS}
            contentLabel={ariaLabel || title}
            style={{ overlay: { zIndex } }}
        >
            <div className="dsh-panel-card">
                <div className="p-10 pb-5">
                    <h2 className="font-bold text-xl text-deepPurple text-left">{title}</h2>
                    {headerContent}
                </div>

                <div id={scrollId} className="dsh-dim gray-small-scroll flex-1 min-h-0 overflow-y-auto mx-2 pb-2" data-loading={refreshing}>
                    {loading && <ContentListSkeleton />}
                    {isEmpty && <div className="dsh-empty h-full flex items-center justify-center text-mudPurple font-medium text-center px-8">{emptyText}</div>}
                    {!loading && items.length > 0 && (
                        <InfiniteScroll
                            dataLength={items.length}
                            next={loadMore}
                            hasMore={hasMore}
                            scrollableTarget={scrollId}
                            scrollThreshold={0.8}
                            loader={
                                <div className="flex justify-center py-4">
                                    <Loading primaryColor="#5E639B" secondaryColor="#DEDCF6" size={24} stroke={6} />
                                </div>
                            }
                        >
                            <div className="dsh-list-animate" key={version}>
                                {items.map(renderRow)}
                            </div>
                        </InfiniteScroll>
                    )}
                </div>
            </div>

            <div className="dsh-panel-footer">
                <FabButton id={closeButton.id} label={closeButton.label} count={closeButton.count} onClick={onClose} icon={UpcomingDropdown} textClassName="text-highlightColor" />
            </div>

            {children}
        </ReactModal>
    )
}

export default ContentListModal
